module.exports = __webpack_public_path__ + "media/pdfs/Prepworks-Academy_Curriculum-and-Package-Information_2022-18d1e33c098c5f27b3b26ba130753754.pdf";